import Vue from 'vue'
import Vuex from 'vuex'
import * as signIn from './SignIn/'
import * as companies from './Companies/'
import * as positions from './PositionList'
import * as users from './UserList'
import * as bankDetails from './BankDetails'
import * as balanceInvoices from './BalanceInvoices'
import * as taxCreditNotes from './CreditNoteList'
import * as serviceCategory from './ServiceCategory'
import * as vendorTags from './VendorTags'
import * as ProjectTags from './ProjectTags'
import * as ListOfRequestTags from './ListOfRequestTags'
import * as serviceInstitutions from './ServiceInstitutions'
import * as serviceProject from './ServiceProject'
import * as servicesList from './ServicesList'
import * as contactsList from './ContactsList'
import * as clientInfo from './Client'
import * as invoicesList from './InvoicesTable'
import * as soaList from './Soa'
import * as balanceAccounts from './BalanceAccounts'
import * as balanceClient from './BalanceClients'
import * as balancePartners from './BalancePartners'
import * as payroll from './Payroll'
import * as listOfPayments from './ListOfPayments'
import * as expensesCategory from './ExpenseCategories'
import * as expenses from './Expenses'
import * as cacheRegister from './CacheRegister'
import * as funds from './Funds'
import * as fundsTransfers from './FundsTransfers'
import * as kpi from './KPI'
import * as creditNotes from './CreditNotes'
import * as gapi from './Gapi'
import * as mainScroll from './Main'
import * as vatDocs from './VATDocs'
import * as contactsProjects from './ContactsProjects'
import * as contactsFinances from './ContactFinances'
import * as writeOff from './WriteOff'
import * as contactDocs from './ContactDocuments'
import * as emailStore from './Email'
import * as logsStore from './Logs'
import * as serviceProviderStore from './ServiceProvider/index'
import * as TimerStore from './Timer/index'
import * as technicalStore from './TechnicalSupport'
import initialState from './ResetStore/index'

Vue.use(Vuex)

const modules = {}
Object.assign(modules, companies.modules)
Object.assign(modules, signIn.modules)
Object.assign(modules, positions.modules)
Object.assign(modules, users.modules)
Object.assign(modules, bankDetails.modules)
Object.assign(modules, serviceCategory.modules)
Object.assign(modules, vendorTags.modules)
Object.assign(modules, ProjectTags.modules)
Object.assign(modules, ListOfRequestTags.modules)
Object.assign(modules, balanceInvoices.modules)
Object.assign(modules, taxCreditNotes.modules)
Object.assign(modules, serviceInstitutions.modules)
Object.assign(modules, serviceProject.modules)
Object.assign(modules, servicesList.modules)
Object.assign(modules, invoicesList.modules)
Object.assign(modules, contactsList.modules)
Object.assign(modules, clientInfo.modules)
Object.assign(modules, soaList.modules)
Object.assign(modules, balanceAccounts.modules)
Object.assign(modules, balanceClient.modules)
Object.assign(modules, balancePartners.modules)
Object.assign(modules, payroll.modules)
Object.assign(modules, listOfPayments.modules)
Object.assign(modules, expensesCategory.modules)
Object.assign(modules, expenses.modules)
Object.assign(modules, cacheRegister.modules)
Object.assign(modules, funds.modules)
Object.assign(modules, fundsTransfers.modules)
Object.assign(modules, kpi.modules)
Object.assign(modules, creditNotes.modules)
Object.assign(modules, gapi.modules)
Object.assign(modules, mainScroll.modules)
Object.assign(modules, vatDocs.modules)
Object.assign(modules, contactsProjects.modules)
Object.assign(modules, contactsFinances.modules)
Object.assign(modules, writeOff.modules)
Object.assign(modules, contactDocs.modules)
Object.assign(modules, emailStore.modules)
Object.assign(modules, logsStore.modules)
Object.assign(modules, serviceProviderStore.modules)
Object.assign(modules, TimerStore.modules)
Object.assign(modules, technicalStore.modules)

export default new Vuex.Store({
  modules,
  mutations: {
    resetStore (state) {
      Object.keys(state).forEach(key => {
        const res = {}
        if (!initialState[key]) return
        Object.keys(initialState[key]).forEach(stateName => {
          if (Array.isArray(initialState[key][stateName])) {
            res[stateName] = []
          } else if (typeof initialState[key][stateName] === 'object') {
            res[stateName] = {}
          } else {
            res[stateName] = ''
          }
          Object.assign(state[key], res)
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js